import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    border: `1px dashed ${theme.borderColor}`,
  },
  addButton: {
    paddingRight: theme.spacing(2)
  },
  button: {
    minWidth: 0,
    widnth: 40,
    padding: theme.spacing(1.5)
  }
}))

export {
  useStyles
}
